import React, { useState } from "react";
import { Typography } from "../../Components/Typography";
import Tabs from "../../Components/Tabs";
import Testimonials from "../Testimonials";
import FAQs from "../FAQs";
import EmailTemplates from "../EmailTemplates";
import MasterData from "../../pages/admin/MasterData";

const Content = () => {
  const [activeTab, setActiveTab] = useState("testimonials");

  const tabs = [
    { id: "testimonials", label: "Testimonials" },
    { id: "faqs", label: "FAQs" },
    { id: "email-template", label: "Email Template" },
    { id: "master-data", label: "MasterData" },
  ];

  return (
    <div className="p-6">
      <Typography as="h1" className="text-2xl font-bold text-primary-900 mb-4 text-start">
        Content
      </Typography>
      
      <div className="space-y-4">
        <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

        <div className="bg-white border border-slate-200 rounded-lg p-6 min-h-[400px] w-full">
          {activeTab === "testimonials" && <Testimonials />}
          {activeTab === "faqs" && <FAQs />}
          {activeTab === "email-template" && <EmailTemplates />}
          {activeTab === "master-data" && <MasterData />}
        </div>
      </div>
    </div>
  );
};

export default Content;

